export default {
  LABEL_NAME: 'Nome completo',
  TITLE_DOCUMENT: 'Quem recebeu?',
  LABEL_DOCUMENT: 'N.º documento',
  BUTTON_CONTINUE: 'Confirmar entrega',
  BUTTON_CONFIRM: 'Coletar pacotes',
  BUTTON_BACK: 'Voltar'
};
